<template>
  <div class="tw-flex tw-relative tw-items-center">
    <ButtonShowMore
      :disabled="disabled"
      :id-popover="`'popover-btn-show-more-${id}'`"
      :is-from-notification="true"
      :icon-class="iconClass"
      :classes="classButton"
      :data-cy-id="dataCyId"
    >
      <template #default>
        <CustomDropDownItem
          v-if="actions.includes(actionClickType.actionManageUser)"
          :data-cy="'manage-user-menu'"
          :style="'normal'"
          :id-text="'app-settings-team-members-more-modal-manage-user-1'"
          @click="() => clickEvent('')"
        />
        <CustomDropDownItem
          v-if="actions.includes(actionClickType.actionResetPassword)"
          :style="'normal'"
          :id-text="'app-settings-team-members-more-modal-reset-password-1'"
          @click="() => clickEvent(actionClickType.actionResetPassword)"
        />
        <CustomDropDownItem
          v-if="actions.includes(actionClickType.actionAddMFA)"
          :style="'normal'"
          :data-cy="'manage-user-menu-add-mfa'"
          :id-text="'app-settings-team-members-profile-modal-add-mfa-action-title-1'"
          @click="() => clickEvent(actionClickType.actionAddMFA)"
        />
        <CustomDropDownItem
          v-if="actions.includes(actionClickType.actionAddAnotherMFA)"
          :style="'normal'"
          :id-text="'app-settings-team-members-profile-modal-add-another-mfa-action-title-1'"
          @click="() => clickEvent(actionClickType.actionAddAnotherMFA)"
        />
        <CustomDropDownItem
          v-if="actions.includes(actionClickType.actionResetMFA)"
          :style="'normal'"
          :data-cy="'manage-user-menu-reset-mfa'"
          :id-text="'app-settings-team-members-more-modal-reset-mfa-1'"
          @click="() => clickEvent(actionClickType.actionResetMFA)"
        />
        <CustomDropDownItem
          v-if="actions.includes(actionClickType.actionEnableMFA)"
          :style="'normal'"
          :data-cy="'manage-user-menu-enable-mfa'"
          :id-text="'app-user-profile-actions-enable-mfa-1'"
          @click="() => clickEvent(actionClickType.actionResetMFA)"
        />
        <CustomDropDownItem
          v-if="
            actions.includes(actionClickType.actionDeactivate) &&
            ((valueItem.status === 'active' && isInternal) || !isInternal)
          "
          :style="'normal'"
          :data-cy="'manage-user-menu-deactive-user'"
          :id-text="'app-settings-team-members-more-modal-deactivate-user-1'"
          @click="() => clickEvent(actionClickType.actionDeactivate)"
        />
        <CustomDropDownItem
          v-if="
            actions.includes(actionClickType.actionActive) &&
            ((valueItem.status === 'deactivated' && isInternal) || !isInternal)
          "
          :style="'normal'"
          :data-cy="'manage-user-menu-active-user'"
          :id-text="'app-settings-team-members-more-modal-activate-user-1'"
          @click="() => clickEvent(actionClickType.actionActive)"
        />
        <CustomDropDownItem
          v-if="actions.includes(actionClickType.actionDownload)"
          :style="'normal'"
          :id-text="'app-common-action-download-title-1'"
          @click="() => clickEvent(actionClickType.actionDownload)"
        />
        <CustomDropDownItem
          v-if="
            actions.includes(actionClickType.actionUnlockUser) &&
            valueItem.isLocked
          "
          :style="'normal'"
          :id-text="'app-settings-team-members-more-modal-unlock-user-1'"
          @click="() => clickEvent(actionClickType.actionUnlockUser)"
        />
        <CustomDropDownItem
          v-if="actions.includes(actionClickType.actionResendInvite)"
          :style="'normal'"
          data-cy="resend-invite-button"
          :id-text="'app-settings-resend-invite-1'"
          @click="() => clickEvent(actionClickType.actionResendInvite)"
        />
        <CustomDropDownItem
          v-if="actions.includes(actionClickType.actionDeleteUser)"
          :style="'danger'"
          :data-cy="'manage-user-menu-delete-user'"
          :id-text="'app-settings-team-members-more-modal-delete-user-1'"
          @click="() => clickEvent(actionClickType.actionDeleteUser)"
        />
        <CustomDropDownItem
          v-if="actions.includes(actionClickType.actionRemoveAccess)"
          :style="'danger'"
          :data-cy="'manage-user-menu-remove-all-access-user'"
          :id-text="'app-settings-team-members-profile-modal-actions-remove-all-access-1'"
          @click="() => clickEvent(actionClickType.actionRemoveAccess)"
        />
        <CustomDropDownItem
          v-if="actions.includes(actionClickType.actionRemoveOrgAccess)"
          :style="'danger'"
          :id-text="'app-settings-team-members-profile-modal-remove-access-button-1'"
          @click="() => clickEvent(actionClickType.actionRemoveOrgAccess)"
        />
        <CustomDropDownItem
          v-if="actions.includes(actionClickType.actionProcessRequest)"
          :style="'normal'"
          :id-text="'app-settings-organisation-manage-access-bulk-actions-modal-accept-request-1'"
          @click="() => clickEvent(actionClickType.actionProcessRequest)"
        />
        <CustomDropDownItem
          v-if="actions.includes(actionClickType.actionProcessOffer)"
          :style="'normal'"
          :id-text="'app-settings-organisation-manage-access-bulk-actions-modal-accept-offer-1'"
          @click="() => clickEvent(actionClickType.actionProcessOffer)"
        />
        <CustomDropDownItem
          v-if="actions.includes(actionClickType.actionRemoveFile)"
          :style="'danger'"
          :id-text="'app-component-assessments-evidence-modal-file-table-action-delete-1'"
          @click="() => clickEvent(actionClickType.actionRemoveFile)"
        />

        <!-- Manage Domain -->
        <CustomDropDownItem
          v-if="
            actions.includes(actionClickType.actionVerifyDomain) &&
            !valueItem?.isVerified.isVerifiedDNS
          "
          :style="'normal'"
          :id-text="'app-settings-domain-verify-domain-1'"
          @click="() => clickEvent(actionClickType.actionVerifyDomain)"
        />
        <CustomDropDownItem
          v-if="
            actions.includes(actionClickType.actionManageDomain) &&
            !valueItem?.isVerified.isVerifiedDNS
          "
          :style="'normal'"
          :id-text="'app-settings-domain-manage-domain-2'"
          @click="() => clickEvent(actionClickType.actionManageDomain)"
        />
        <CustomDropDownItem
          v-if="
            actions.includes(actionClickType.actionUnVerifyDomain) &&
            valueItem?.isVerified.isVerifiedDNS
          "
          :style="'normal'"
          data-cy="un-verify-domain-button"
          :id-text="'app-settings-domain-un-verify-domain-1'"
          @click="() => clickEvent(actionClickType.actionUnVerifyDomain)"
        />
        <CustomDropDownItem
          v-if="actions.includes(actionClickType.actionUnVerifyEmail)"
          :style="'normal'"
          data-cy="un-verify-email-button"
          :id-text="'app-settings-domain-un-verify-email-1'"
          @click="() => clickEvent(actionClickType.actionUnVerifyEmail)"
        />
        <CustomDropDownItem
          v-if="
            actions.includes(actionClickType.actionSendVerificationEmail) &&
            !valueItem?.isVerified.isVerifiedEmail
          "
          :style="'normal'"
          :id-text="'app-settings-domain-send-verification-email-1'"
          @click="() => clickEvent(actionClickType.actionSendVerificationEmail)"
        />
        <CustomDropDownItem
          v-if="actions.includes(actionClickType.actionDeleteDomain)"
          :style="'danger'"
          data-cy="delete-domain-button"
          :id-text="'app-settings-domain-delete-domain-1'"
          @click="() => clickEvent(actionClickType.actionDeleteDomain)"
        />
        <CustomDropDownItem
          v-if="actions.includes(actionClickType.actionEditActionRecomendation)"
          :style="'normal'"
          :id-text="'app-assess-recommendations-section-action-edit-action-option-1'"
          @click="
            () => clickEvent(actionClickType.actionEditActionRecomendation)
          "
        />
        <CustomDropDownItem
          v-if="actions.includes(actionClickType.actionShowAssessmentsAdvanced)"
          :style="'normal'"
          :id-text="'app-component-assessments-advanced-title-1'"
          @click="
            () => clickEvent(actionClickType.actionShowAssessmentsAdvanced)
          "
        />
        <CustomDropDownItem
          v-if="
            actions.includes(actionClickType.actionMarkAsComplete) &&
            (valueItem.checklistGroupCompletionPcnt === null ||
              valueItem.checklistGroupCompletionPcnt !== 1)
          "
          :style="'normal'"
          :id-text="'app-assess-recommend-action-status-mark-1'"
          :custom-text-class="`tw-flex tw-items-center tw-gap-[5px]`"
          :tag-status="CHECKLISTSTATUS.DONE"
          :tag-status-id="CHECKLISTSTATUS.DONE"
          @click="() => clickEvent(actionClickType.actionMarkAsComplete)"
        />
        <CustomDropDownItem
          v-if="
            actions.includes(actionClickType.actionMarkAsInProgress) &&
            (valueItem.checklistGroupCompletionPcnt === null ||
              valueItem.checklistGroupCompletionPcnt === 0 ||
              valueItem.checklistGroupCompletionPcnt === 1)
          "
          :style="'normal'"
          :id-text="'app-assess-recommend-action-status-mark-1'"
          :custom-text-class="`tw-flex tw-items-center tw-gap-[5px]`"
          :tag-status="CHECKLISTSTATUS.INPROG"
          :tag-status-id="CHECKLISTSTATUS.INPROG"
          @click="() => clickEvent(actionClickType.actionMarkAsInProgress)"
        />
        <CustomDropDownItem
          v-if="
            actions.includes(actionClickType.actionMarkAsNotStarted) &&
            (valueItem.checklistGroupCompletionPcnt === null ||
              valueItem.checklistGroupCompletionPcnt !== 0)
          "
          :style="'normal'"
          :id-text="'app-assess-recommend-action-status-mark-1'"
          :custom-text-class="`tw-flex tw-items-center tw-gap-[5px]`"
          :tag-status="CHECKLISTSTATUS.NOT_STARTED"
          :tag-status-id="CHECKLISTSTATUS.NOT_STARTED"
          @click="() => clickEvent(actionClickType.actionMarkAsNotStarted)"
        />
        <CustomDropDownItem
          v-if="
            actions.includes(actionClickType.actionClearStatus) &&
            valueItem.checklistGroupCompletionPcnt !== null
          "
          :style="'normal'"
          :id-text="'app-assess-recommend-action-clear-status-1'"
          @click="() => clickEvent(actionClickType.actionClearStatus)"
        />
        <CustomDropDownItem
          v-if="
            actions.includes(
              actionClickType.actionMarkAsQuickWinRecomendation,
            ) && valueItem.checklistGroupIsQuickWin
          "
          :data-cy="'manage-user-menu-quickwin-recommendation'"
          :style="'normal'"
          :id-text="'app-assess-recommend-action-mark-quickwin-1'"
          @click="
            () => clickEvent(actionClickType.actionMarkAsQuickWinRecomendation)
          "
        />
        <CustomDropDownItem
          v-if="
            actions.includes(
              actionClickType.actionMarkAsQuickWinRecomendation,
            ) && !valueItem.checklistGroupIsQuickWin
          "
          :style="'normal'"
          :data-cy="'manage-user-menu-not-quickwin-recommendation'"
          :id-text="'app-assess-recommend-action-mark-notquickwin-1'"
          @click="
            () => clickEvent(actionClickType.actionMarkAsQuickWinRecomendation)
          "
        />
        <CustomDropDownItem
          v-if="
            actions.includes(actionClickType.actionDeleteActionRecomendation)
          "
          :style="'danger'"
          :id-text="'app-assess-recommend-action-delete-action-1'"
          @click="
            () => clickEvent(actionClickType.actionDeleteActionRecomendation)
          "
        />
        <CustomDropDownItem
          v-if="actions.includes(actionClickType.actionAddActionQuestion)"
          :style="'normal'"
          :id-text="'app-assess-recommendations-action-table-bulk-actions-modal-add-action-1'"
          @click="() => clickEvent(actionClickType.actionAddActionQuestion)"
        />
        <CustomDropDownItem
          v-if="actions.includes(actionClickType.actionRemoveFormAction)"
          :style="'danger'"
          :id-text="'app-assess-recommendations-action-table-bulk-actions-modal-remove-from-action-1'"
          @click="() => clickEvent(actionClickType.actionRemoveFormAction)"
        />
        <CustomDropDownItem
          v-if="actions.includes(actionClickType.actionRestoreUser)"
          :style="'normal'"
          :id-text="'app-assess-recommendations-action-table-bulk-actions-restore-user-1'"
          @click="() => clickEvent(actionClickType.actionRestoreUser)"
        />
      </template>
    </ButtonShowMore>
    <div
      v-if="inModalEdit"
      style="position: relative; z-index: 0"
      class="tw-flex tw-items-center tw-justify-center tw-absolute tw-right-0 tw-w-7 tw-h-7 tw-rounded-full tw-border tw-border-solid tw-border-[#EFF0F1] tw-bg-[#fff] tw-cursor-pointer"
      @click="() => clickEvent(actionClickType.actionDeleteActionQuestion)"
    >
      <div class="tw-w-2 tw-h-[2px] tw-bg-[#ff7f50]" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { PropType, onMounted, onUpdated, ref } from "vue";
import ButtonShowMore from "./buttonShowMore.vue";
import CustomDropDownItem from "../customDropDownItem.vue";
import { actionClickType, CHECKLISTSTATUS } from "@/utils/constants";

const emit = defineEmits(["manage-user"]);
const props = defineProps({
  isInternal: { type: Boolean, default: false },
  actions: { type: Array as PropType<string[]>, default: () => [""] },
  classValue: { type: String, default: "" },
  value: { type: Object as PropType<any>, required: true },
  iconClass: { type: String, default: "", required: false },
  inModalEdit: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  id: { type: String, default: "", required: false },
  dataCyId: { type: String, default: "", required: false },
  classButton: { type: String, default: "" },
});

const valueItem: any = ref(props.value.item);
const isInternal: any = ref(props.isInternal);

onMounted(() => {
  valueItem.value = props.value.item;
  isInternal.value = props.isInternal;
});

onUpdated(() => {
  valueItem.value = props.value.item;
  isInternal.value = props.isInternal;
});

const clickEvent = (action: any = "") => {
  if (isInternal.value)
    emit("manage-user", valueItem.value, action, isInternal.value);
  else emit("manage-user", valueItem.value, action);
};
</script>
